<template>
  <div style="font-family: Arial, sans-serif; padding: 20px;">
    <input
      type="file"
      ref="fileInput"
      multiple
      accept="image/*"
      style="display: none"
      @change="handleFilesSelected"
    />
    <f7-button @click="openFileDialog" fill color="#1d2244" style="width: fit-content;">
      CARGAR IMÁGENES
    </f7-button>

    <ul
      class="image-list"
    >
      <li
        v-for="img in images"
        :key="img.name"
        style="display: flex; align-items: center; gap: 10px; border-bottom: 1px solid #ccc; padding: 8px 0;"
      >
        <img
          :src="img.data"
          :alt="img.name"
          width="60"
          height="60"
          style="border-radius: 6px; border: 1px solid #ddd;"
        />
        <span style="flex: 1" class="nowrap">{{ img.name }}</span>
        <f7-button @click="removeImage(img.name)" fill color="red">X</f7-button>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ImageUploader",
  props: {
    value: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      internalImages: [],
      imagesBase64:[]
    };
  },
  computed: {
    images() {
      return this.value !== null ? this.value : this.internalImages;
    },
  },
  methods: {
    openFileDialog() {
      this.$refs.fileInput.click();
    },
    handleFilesSelected(event) {
      const files = event.target.files ? Array.from(event.target.files) : [];

      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const newImage = {
            name: file.name,
            data: e.target.result,
            remoteName: ''
          };

          this.uploadImages(newImage)
          const updated = [...this.images, newImage];

          if (this.value !== null) {
            this.$emit("input", updated);
            this.$emit("change", updated);
          } else {
            this.internalImages = updated;
            this.$emit("change", updated);
          }
        };
        reader.readAsDataURL(file);
      });

      event.target.value = "";
    },
    removeImage(name) {
      const updated = this.images.filter((img) => img.name !== name);

      if (this.value !== null) {
        this.$emit("input", updated);
        this.$emit("change", updated);
      } else {
        this.internalImages = updated;
        this.$emit("change", updated);
      }
    },
    async uploadImages(file){
      await this.$api.envio.uploadImage(file)
      .then((response) => {
        this.$emit('upload', response)
      })
    }
  },
};
</script>

<style scoped>
.nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.image-list{
  list-style: none;
  padding: 0;
  margin-top: 20px;
  width: 100%;
  max-width: 400px;
}
</style>